<div class="nerf-simulator-container">

  <!-- Center-of-interest selector (kept OUTSIDE the form: cityControl is a standalone
       control, not part of simulatorForm) -->
  <div class="container-fluid px-0">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="nerf-city-select w-100">
          <mat-label>{{ 'components.nerf-simulator.select_center_of_interest' | translate }}</mat-label>
          <mat-select [formControl]="cityControl" (selectionChange)="onCitySelected($event.value)"
                      (openedChange)="onCityPanelOpenedChange($event)"
                      [placeholder]="'components.nerf-simulator.select_center_of_interest' | translate">
            <div class="nerf-city-search-box">
              <input #citySearchInput type="text" class="nerf-city-search-input"
                     [placeholder]="'components.nerf-simulator.search_city' | translate"
                     (keydown)="$event.stopPropagation()"
                     (input)="onCitySearch($any($event.target).value)">
            </div>
            @for (record of filteredCityRecords; track record.id) {
              <mat-option [value]="record.id">{{ record.city }}</mat-option>
            }
            @if (filteredCityRecords.length === 0) {
              <div class="nerf-city-search-empty">{{ 'components.nerf-simulator.no_results' | translate }}</div>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <form [formGroup]="simulatorForm" (ngSubmit)="onSubmit()">
    <div class="container-fluid px-0">

      <!-- Due colonne: a sinistra i parametri in tre schede, a destra i risultati (metriche chiave) -->
      <div class="row">
        <!-- LEFT COLUMN: PARAMETRI IN SCHEDE -->
        <div class="col-12 col-lg-7">
          <mat-tab-group animationDuration="300ms">

            <!-- Scheda 1: parametri di ingresso (modificabili) -->
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="mr-2" aria-hidden="true">edit</mat-icon>
                {{ 'components.nerf-simulator.editable_parameters' | translate }}
                @if (simulatorForm.errors?.['compositionSumExceeded']) {
                  <mat-icon class="ml-1" color="warn" aria-hidden="true">error</mat-icon>
                }
              </ng-template>
              <div class="pt-3 px-1 pb-3">
                <div class="parameters-table editable-section h-auto mb-0">
                  <div class="d-flex align-items-center justify-content-end mb-2">
                    <button mat-stroked-button color="primary" type="button" (click)="openHelp('editable')">
                      <mat-icon>help_outline</mat-icon>
                      <span class="ml-1">{{ 'components.nerf-simulator.help.button' | translate }}</span>
                    </button>
                  </div>
                  <!-- Un solo table-section per card: tutti i campi modificabili -->
                  <div class="table-section">
                    <div class="table-grid-single">
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.ublituximab_composition' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ublituximab_composition" step="0.1"
                               [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                        <span class="table-unit">%</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.intravenous_ocrelizumab_composition' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ocrelizumab_intravenous_composition" step="0.1"
                          [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                        <span class="table-unit">%</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.rituximab_composition' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ocrelizumab_subcutaneous_composition" step="0.1"
                               [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                        <span class="table-unit">%</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.natalizumab_intravenous_composition' | translate }}</label>
                        <input type="number" class="table-input" formControlName="natalizumab_intravenous_composition" step="0.1"
                               [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                        <span class="table-unit">%</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.natalizumab_subcutaneous_composition' | translate }}</label>
                        <input type="number" class="table-input" formControlName="natalizumab_subcutaneous_composition" step="0.1"
                               [class.is-invalid]="simulatorForm.errors?.['compositionSumExceeded']">
                        <span class="table-unit">%</span>
                      </div>
                    <!-- Composition Sum Validation Error -->
                    @if (simulatorForm.errors?.['compositionSumExceeded']) {
                      <div class="alert alert-danger mt-2" role="alert">
                        <i class="icon-Alert-Triangle mr-2"></i>
                        <strong>{{ 'components.nerf-simulator.composition_sum_error_message' | translate }}</strong>
                        ({{ simulatorForm.errors?.['compositionSumExceeded'].sum | number:'1.0-2' }}% / {{ simulatorForm.errors?.['compositionSumExceeded'].max }}%)
                      </div>
                    }

                    <!-- Operational (Gap_Min, …) -->
                    <!-- <h5 class="section-header">{{ 'components.nerf-simulator.operational_parameters' | translate }}</h5> -->
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.gap_min' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Gap_Min" step="1">
                        <span class="table-unit">min</span>
                      </div>
                      <!--
                        DEV / UX: campo nascosto (non eliminare senza decisione esplicita).
                        Il FormControl `Avg_Infusion_Min_Scenario` resta in nerf-simulator.component.ts e partecipa ancora a getRawValue()/submit.
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.avg_infusion_min_scenario' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Avg_Infusion_Min_Scenario" step="1">
                        <span class="table-unit">min</span>
                      </div>
                      -->
                      <!--
                        DEV / UX: campo nascosto (non eliminare senza decisione esplicita).
                        Il FormControl `Gap_TimeHours_Per_Day` resta in nerf-simulator.component.ts e partecipa ancora a getRawValue()/submit.
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.gap_time_hours_per_day' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Gap_TimeHours_Per_Day" step="0.5">
                        <span class="table-unit">h</span>
                      </div>
                      -->

                    <!-- Staff & Capacity -->
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.nurses_per_shift' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Nurses_per_Shift" step="1">
                        <span class="table-unit"></span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.patients_per_nurse' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Patients_per_Nurse" step="1">
                        <span class="table-unit"></span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.chairs_active' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Chairs_Active" step="1">
                        <span class="table-unit"></span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.number_of_opening_days' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Working_Days_Month" step="1">
                        <span class="table-unit">days</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.hours_per_day' | translate }}</label>
                        <input type="number" class="table-input" formControlName="Hours_Per_Day" step="0.5">
                        <span class="table-unit">h</span>
                      </div>
                    </div>
                  </div>

                  <!-- Parametri avanzati (fondo box "Parametri di ingresso"): Safety_Buffer + No_Show_Rate -->
                  <div class="table-section nerf-editable-advanced-section">
                    <mat-accordion class="expansion-panels-cards nerf-editable-advanced-accordion" multi="false">
                      <mat-expansion-panel class="expansion-panel-card">
                        <mat-expansion-panel-header>
                          <mat-panel-title class="d-flex align-items-center">
                            <mat-icon class="section-icon mr-2" aria-hidden="true">tune</mat-icon>
                            {{ 'components.nerf-simulator.advanced_parameters' | translate }}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="table-grid-single nerf-advanced-panel-fields">
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.safety_buffer' | translate }}</label>
                            <input type="number" class="table-input" formControlName="Safety_Buffer" step="0.01">
                            <span class="table-unit">%</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.no_show_rate' | translate }}</label>
                            <input type="number" class="table-input" formControlName="No_Show_Rate" step="0.01" min="0" max="100">
                            <span class="table-unit">%</span>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </div>
            </mat-tab>

            <!-- Scheda 2: parametri fissi (sola lettura) -->
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="mr-2" aria-hidden="true">lock</mat-icon>
                {{ 'components.nerf-simulator.readonly_parameters' | translate }}
              </ng-template>
              <div class="pt-3 px-1 pb-3">
                <div class="parameters-table readonly-section h-auto mb-0">
                  <div class="d-flex align-items-center justify-content-end mb-2">
                    <button mat-stroked-button color="primary" type="button" (click)="openHelp('fixed')">
                      <mat-icon>help_outline</mat-icon>
                      <span class="ml-1">{{ 'components.nerf-simulator.help.button' | translate }}</span>
                    </button>
                  </div>
                  <!-- Medication Duration -->
                  <div class="table-section">
                    <!-- <h5 class="section-header">{{ 'components.nerf-simulator.medication_parameters' | translate }}</h5> -->
                    <div class="table-grid-single">
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.ublituximab_min' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ublituximab_min" step="1">
                        <span class="table-unit">min</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.ocrelizumab_min_intravenous' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ocrelizumab_intravenous_min" step="1">
                        <span class="table-unit">min</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.rituximab_min_subcutaneous' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ocrelizumab_subcutaneous_min" step="1">
                        <span class="table-unit">min</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.natalizumab_intravenous_min' | translate }}</label>
                        <input type="number" class="table-input" formControlName="natalizumab_intravenous_min" step="1">
                        <span class="table-unit">min</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.natalizumab_subcutaneous_min' | translate }}</label>
                        <input type="number" class="table-input" formControlName="natalizumab_subcutaneous_min" step="1">
                        <span class="table-unit">min</span>
                      </div>
                    </div>
                  </div>

                  <!-- Tempi (sola lettura): stesso titolo e icona del pannello "Parametri avanzati" a sinistra -->
                  <div class="table-section nerf-readonly-fixed-section">
                    <mat-accordion class="expansion-panels-cards nerf-readonly-fixed-accordion" multi="false">
                      <mat-expansion-panel class="expansion-panel-card">
                        <mat-expansion-panel-header>
                          <mat-panel-title class="d-flex align-items-center">
                            <mat-icon class="section-icon mr-2" aria-hidden="true">tune</mat-icon>
                            {{ 'components.nerf-simulator.advanced_parameters' | translate }}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="table-grid-single nerf-fixed-panel-fields">
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.prep_time_chair_materials' | translate }}</label>
                            <input type="number" class="table-input" formControlName="prep_time_chair_materials" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.patient_reception_assessment_time' | translate }}</label>
                            <input type="number" class="table-input" formControlName="patient_reception_assessment_time" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.vitals_premedication_setup_time' | translate }}</label>
                            <input type="number" class="table-input" formControlName="vitals_premedication_setup_time" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.post_infusion_surveillance_time_ocrelizumab_subcutaneous' | translate }}</label>
                            <input type="number" class="table-input" formControlName="post_infusion_surveillance_time_ocrelizumab_subcutaneous" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.post_infusion_surveillance_time_ocrelizumab_intravenous' | translate }}</label>
                            <input type="number" class="table-input" formControlName="post_infusion_surveillance_time_ocrelizumab_intravenous" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.post_infusion_surveillance_time_ublituximab' | translate }}</label>
                            <input type="number" class="table-input" formControlName="post_infusion_surveillance_time_ublituximab" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.post_infusion_surveillance_time_natalizumab_intravenous' | translate }}</label>
                            <input type="number" class="table-input" formControlName="post_infusion_surveillance_time_natalizumab_intravenous" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.post_infusion_surveillance_time_natalizumab_subcutaneous' | translate }}</label>
                            <input type="number" class="table-input" formControlName="post_infusion_surveillance_time_natalizumab_subcutaneous" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.post_infusion_admin_time' | translate }}</label>
                            <input type="number" class="table-input" formControlName="post_infusion_admin_time" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.avg_operational_gap_between_infusions' | translate }}</label>
                            <input type="number" class="table-input" formControlName="avg_operational_gap_between_infusions" step="0.01">
                            <span class="table-unit">min</span>
                          </div>
                          <!-- Somministrazioni annue per terapia (da input_data del centro) -->
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.ocrelizumab_subcutaneous_administrations_per_year' | translate }}</label>
                            <input type="number" class="table-input" formControlName="ocrelizumab_subcutaneous_administrations_per_year" step="0.01">
                            <span class="table-unit"></span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.ocrelizumab_intravenous_administrations_per_year' | translate }}</label>
                            <input type="number" class="table-input" formControlName="ocrelizumab_intravenous_administrations_per_year" step="0.01">
                            <span class="table-unit"></span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.ublituximab_administrations_per_year' | translate }}</label>
                            <input type="number" class="table-input" formControlName="ublituximab_administrations_per_year" step="0.01">
                            <span class="table-unit"></span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.natalizumab_intravenous_administrations_per_year' | translate }}</label>
                            <input type="number" class="table-input" formControlName="natalizumab_intravenous_administrations_per_year" step="0.01">
                            <span class="table-unit"></span>
                          </div>
                          <div class="table-row-single">
                            <label class="table-label">{{ 'components.nerf-simulator.natalizumab_subcutaneous_administrations_per_year' | translate }}</label>
                            <input type="number" class="table-input" formControlName="natalizumab_subcutaneous_administrations_per_year" step="0.01">
                            <span class="table-unit"></span>
                          </div>
                        </div>
                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>
                </div>
              </div>
            </mat-tab>

            <!-- Scheda 3: parametri costi -->
            <mat-tab>
              <ng-template mat-tab-label>
                <mat-icon class="mr-2" aria-hidden="true">payments</mat-icon>
                {{ 'components.nerf-simulator.cost_parameters' | translate }}
              </ng-template>
              <div class="pt-3 px-1 pb-3">
                <div class="parameters-table editable-section h-auto mb-0">
                  <div class="d-flex align-items-center justify-content-end mb-2">
                    <button mat-stroked-button color="primary" type="button" (click)="openHelp('costs')">
                      <mat-icon>help_outline</mat-icon>
                      <span class="ml-1">{{ 'components.nerf-simulator.help.button' | translate }}</span>
                    </button>
                  </div>
                  <div class="table-section">
                    <div class="table-grid-single">
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.ublituximab_cost_single_infusion' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ublituximab_cost_single_infusion" step="0.01" min="0">
                        <span class="table-unit">€</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.intravenous_ocrelizumab_cost_single_infusion' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ocrelizumab_intravenous_cost_single_infusion" step="0.01" min="0">
                        <span class="table-unit">€</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.subcutaneous_ocrelizumab_cost_single_infusion' | translate }}</label>
                        <input type="number" class="table-input" formControlName="ocrelizumab_subcutaneous_cost_single_infusion" step="0.01" min="0">
                        <span class="table-unit">€</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.natalizumab_intravenous_cost_single_infusion' | translate }}</label>
                        <input type="number" class="table-input" formControlName="natalizumab_intravenous_cost_single_infusion" step="0.01" min="0">
                        <span class="table-unit">€</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.natalizumab_subcutaneous_cost_single_infusion' | translate }}</label>
                        <input type="number" class="table-input" formControlName="natalizumab_subcutaneous_cost_single_infusion" step="0.01" min="0">
                        <span class="table-unit">€</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.materials_cost_single_infusion' | translate }}</label>
                        <input type="number" class="table-input" formControlName="materials_cost_single_infusion" step="0.01" min="0">
                        <span class="table-unit">€</span>
                      </div>
                      <div class="table-row-single">
                        <label class="table-label">{{ 'components.nerf-simulator.nurses_cost_for_hour' | translate }}</label>
                        <input type="number" class="table-input" formControlName="nurses_cost_for_hour" step="0.01" min="0">
                        <span class="table-unit">€/h</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>

          <!-- Action Buttons Section -->
          <div class="my-4">
            <div class="nerf-form-actions">
              <button mat-stroked-button color="primary" type="button" class="nerf-form-actions__btn"
                (click)="onReset()" [disabled]="loading || !cityControl.value">
                {{ 'components.nerf-simulator.reset_parameters' | translate }}
              </button>
              <button mat-raised-button color="primary" type="submit" class="nerf-form-actions__btn"
                [disabled]="simulatorForm.invalid || loading || !cityControl.value">
                <mat-icon class="mr-2" aria-hidden="true">auto_fix_high</mat-icon>
                {{ 'generic.buttons.simulate' | translate }}
              </button>
            </div>
          </div>
        </div>

        <!-- RIGHT COLUMN: RISULTATI (metriche chiave); l'id serve allo scroll da "Visualizza" nello storico -->
        <div class="col-12 col-lg-5">
          <div id="nerf-simulation-results-anchor" class="parameters-table readonly-section">
            <div class="section-main-header section-title-purple">
              <mat-icon class="section-icon mr-2" aria-hidden="true">analytics</mat-icon>
              {{ 'components.nerf-simulator.key_metrics' | translate }}
              @if (hasResult && !loading && currentSimulationCreatedAt) {
                <small class="text-muted ml-auto">{{ currentSimulationCreatedAt | date:'d MMMM y, HH:mm' }}</small>
              }
            </div>

            @if (loading) {
              <div class="loading-container nerf-simulate-loading">
                <mat-spinner diameter="44" color="primary" aria-hidden="true"></mat-spinner>
                <p>{{ 'components.nerf-simulator.loading' | translate }}</p>
              </div>
            } @else if (hasResult) {
              <div class="nerf-results-inner p-0">
                <div class="kpi-section mb-4">
                  <div class="kpi-operational-section">
                    <div class="kpi-operational-header">
                      <mat-icon class="kpi-operational-header-icon" aria-hidden="true">analytics</mat-icon>
                      <span>{{ 'components.nerf-simulator.operational_metrics' | translate }}</span>
                    </div>
                    <div class="kpi-cards-row">
                      <!-- <div class="kpi-card kpi-primary">
                        <div class="kpi-icon">
                          <mat-icon aria-hidden="true">percent</mat-icon>
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">{{ 'components.nerf-simulator.utilization_percent' | translate }}</div>
                          <div class="kpi-value">{{ simulationResult.utilization_percent | number:'1.2-2' }}%</div>
                        </div>
                      </div> -->
                      <div class="kpi-card kpi-success">
                        <div class="kpi-icon">
                          <mat-icon aria-hidden="true">groups</mat-icon>
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">{{ 'components.nerf-simulator.patients_per_month' | translate }}</div>
                          <div class="kpi-value">{{ simulationResult.patients_per_month | number:'1.0-0' }}</div>
                        </div>
                      </div>
                      <div class="kpi-card kpi-info">
                        <div class="kpi-icon">
                          <mat-icon aria-hidden="true">timer</mat-icon>
                        </div>
                        <div class="kpi-content">
                          <div class="kpi-label">{{ 'components.nerf-simulator.avg_infusion_time_mix' | translate }}</div>
                          <div class="kpi-value">{{ simulationResult.avg_infusion_time_mix | number:'1.1-1' }} <span class="unit">min</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="kpi-costs-section">
                    <div class="kpi-costs-header">
                      <mat-icon class="kpi-costs-header-icon" aria-hidden="true">payments</mat-icon>
                      <span>{{ 'components.nerf-simulator.cost_parameters' | translate }}</span>
                    </div>
                    <div class="kpi-cards-row">
                    <div class="kpi-card kpi-primary kpi-cost-card">
                      <div class="kpi-icon">
                        <mat-icon aria-hidden="true">payments</mat-icon>
                      </div>
                      <div class="kpi-content">
                        <div class="kpi-label">{{ 'components.nerf-simulator.total_yearly_cost' | translate }}</div>
                        <div class="kpi-value">
                          @if (simulationResult.cost_for_year != null) {
                            {{ simulationResult.cost_for_year | number:'1.2-2' }} <span class="unit">EUR</span>
                          } @else {
                            -
                          }
                        </div>
                      </div>
                    </div>
                    <div class="kpi-card kpi-success kpi-cost-card">
                      <div class="kpi-icon">
                        <mat-icon aria-hidden="true">person</mat-icon>
                      </div>
                      <div class="kpi-content">
                        <div class="kpi-label">{{ 'components.nerf-simulator.cost_per_patient_year' | translate }}</div>
                        <div class="kpi-value">
                          @if (simulationResult.cost_per_patient_year != null) {
                            {{ simulationResult.cost_per_patient_year | number:'1.2-2' }} <span class="unit">EUR</span>
                          } @else {
                            -
                          }
                        </div>
                      </div>
                    </div>
                    <div class="kpi-card kpi-info kpi-cost-card">
                      <div class="kpi-icon">
                        <mat-icon aria-hidden="true">monitoring</mat-icon>
                      </div>
                      <div class="kpi-content">
                        <div class="kpi-label">{{ 'components.nerf-simulator.average_cost_mix' | translate }}</div>
                        <div class="kpi-value">{{ simulationResult.avg_cost_mix | number:'1.2-2' }} <span class="unit">EUR</span></div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
                <!-- Tutti i dati della simulazione: aperti in un modale (openAllData) -->
                <div class="d-flex justify-content-end mt-3">
                  <button mat-stroked-button color="primary" type="button" (click)="openAllData()">
                    <mat-icon>list</mat-icon>
                    <span class="ml-1">{{ 'components.nerf-simulator.all_data' | translate }}</span>
                  </button>
                </div>
              </div>
            } @else {
              <div class="loading-container py-5">
                <mat-icon class="mb-2" color="primary" aria-hidden="true">insights</mat-icon>
                <p class="mb-0">{{ 'components.nerf-simulator.results_placeholder' | translate }}</p>
              </div>
            }
          </div>
        </div>
      </div>

      <!-- Simulation History Section (stesso pattern survey-details: expansion-panel + tabella) -->
      @if (simulationHistory.length > 0) {
        <div class="row my-4">
          <div class="col-12">
            <mat-accordion class="expansion-panels-cards" multi>
              <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="d-flex align-items-center">
                    <mat-icon class="section-icon mr-2" aria-hidden="true">history</mat-icon>
                    {{ 'components.nerf-simulator.simulation_history' | translate }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="d-flex align-items-center justify-content-end mb-2">
                  <button mat-stroked-button color="primary" type="button"
                    (click)="toggleShowAllSimulations()">
                    <mat-icon>{{ showAllSimulations ? 'filter_alt' : 'filter_alt_off' }}</mat-icon>
                    <span class="ml-1">
                      {{ (showAllSimulations ? 'components.nerf-simulator.show_selected_only' : 'components.nerf-simulator.show_all_simulations') | translate }}
                    </span>
                  </button>
                </div>
                <div class="table-container-rounded">
                  <table mat-table [dataSource]="displayedSimulationHistory" class="w-100 table-primary">
                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox
                          [checked]="allSimulationsSelected"
                          [indeterminate]="someSimulationsSelected"
                          (change)="toggleSelectAll($event.checked)"
                          (click)="$event.stopPropagation()">
                        </mat-checkbox>
                      </th>
                      <td mat-cell *matCellDef="let simulation" (click)="$event.stopPropagation()">
                        <mat-checkbox
                          [checked]="isSimulationSelected(simulation)"
                          (change)="toggleSimulationSelection(simulation, $event.checked)">
                        </mat-checkbox>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="created_at">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.simulation_date' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">{{ simulation.created_at | date:'short' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="city">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.center' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">
                        <div>{{ simulation.city || '-' }}</div>
                        @if (simulation.composition_summary) {
                          <small class="text-muted">{{ simulation.composition_summary }}</small>
                        }
                      </td>
                    </ng-container>
                    <!-- Indice di rotazione: resta nello storico anche se non è più tra le metriche chiave -->
                    <ng-container matColumnDef="rotation_index">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.rotation_index' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">
                        @if (simulation.output_results?.rotation_index != null) {
                          {{ simulation.output_results.rotation_index | number:'1.2-2' }}
                        } @else {
                          -
                        }
                      </td>
                    </ng-container>
                    <!-- Costo annuo per paziente; le simulazioni salvate prima dei costi annui mostrano '-' -->
                    <ng-container matColumnDef="cost_per_patient_year">
                      <th mat-header-cell *matHeaderCellDef>{{ 'components.nerf-simulator.cost_per_patient_year' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation">
                        @if (simulation.output_results?.cost_per_patient_year != null) {
                          {{ simulation.output_results.cost_per_patient_year | number:'1.2-2' }} EUR
                        } @else {
                          -
                        }
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef class="right">{{ 'components.nerf-simulator.actions' | translate }}</th>
                      <td mat-cell *matCellDef="let simulation" class="right" (click)="$event.stopPropagation()">
                        <!-- Azioni compatte (icone + tooltip, come modal-show-evidences); elimina in rosso per ultima -->
                        <div class="d-flex align-items-center justify-content-end">
                          <button mat-icon-button color="primary" type="button"
                            [matTooltip]="'generic.view' | translate"
                            [attr.aria-label]="'generic.view' | translate"
                            (click)="loadSimulation(simulation); $event.stopPropagation();">
                            <mat-icon>visibility</mat-icon>
                          </button>
                          <button mat-icon-button color="primary" type="button"
                            [matTooltip]="'generic.export-data' | translate"
                            [attr.aria-label]="'generic.export-data' | translate"
                            (click)="exportToExcel(simulation.id); $event.stopPropagation();">
                            <mat-icon>file_download</mat-icon>
                          </button>
                          <button mat-icon-button color="warn" type="button"
                            [matTooltip]="'generic.delete' | translate"
                            [attr.aria-label]="'generic.delete' | translate"
                            (click)="handleDeleteClick($event, simulation.id)">
                            <mat-icon>delete</mat-icon>
                          </button>
                        </div>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="historyDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: historyDisplayedColumns;"></tr>
                  </table>
                </div>
                @if (loadingHistory) {
                  <div class="text-center mt-3 pb-2">
                    <mat-spinner diameter="30"></mat-spinner>
                  </div>
                }

                <!-- Genera Report AI sulle simulazioni selezionate -->
                <div class="d-flex align-items-center justify-content-between mt-3 pb-2 flex-wrap">
                  <small class="text-muted">
                    {{ selectedSimulationIds.size }}
                    {{ 'components.nerf-simulator.selected_simulations' | translate }}
                  </small>
                  <div class="d-flex align-items-center flex-wrap">
                    <!-- Confronto grafico: attivo con almeno 2 simulazioni selezionate -->
                    <button mat-stroked-button color="primary" type="button" class="mr-2"
                      [disabled]="selectedSimulationIds.size < 2"
                      (click)="openComparisonCharts()">
                      <span>{{ 'components.nerf-simulator.compare_simulations' | translate }}</span>
                      <mat-icon iconPositionEnd>bar_chart</mat-icon>
                    </button>
                    <button mat-raised-button color="primary" type="button"
                      [disabled]="selectedSimulationIds.size === 0 || generatingReport"
                      (click)="generateReport()">
                      <span>{{ 'components.nerf-simulator.generate_report' | translate }}</span>
                      @if (generatingReport) {
                        <mat-spinner diameter="18" class="ml-2 d-inline-block align-middle"></mat-spinner>
                      } @else {
                        <mat-icon iconPositionEnd>summarize</mat-icon>
                      }
                    </button>
                  </div>
                </div>

                @if (currentReport) {
                  <div class="mt-2 p-3 table-container-rounded">
                    <div class="d-flex align-items-center mb-2">
                      <mat-icon class="section-icon mr-2" aria-hidden="true">summarize</mat-icon>
                      <strong>{{ 'components.nerf-simulator.report_title' | translate }}</strong>
                      <span class="badge badge-secondary ml-2">{{ currentReport.status }}</span>
                      @if (reportResultText) {
                        <button mat-button color="primary" type="button" class="ml-auto"
                          (click)="downloadReportWord()">
                          <small>{{ 'components.nerf-simulator.download_report_word' | translate }}</small>
                          <mat-icon iconPositionEnd>description</mat-icon>
                        </button>
                      }
                    </div>

                    @if (currentReport.status === 'processing' || currentReport.status === 'pending') {
                      <div class="d-flex align-items-center">
                        <mat-spinner diameter="20" class="mr-2"></mat-spinner>
                        <small>{{ 'components.nerf-simulator.report_processing' | translate }}</small>
                      </div>
                    } @else if (currentReport.status === 'failed') {
                      <small class="text-danger">
                        {{ currentReport.error_message || ('components.nerf-simulator.report_failed' | translate) }}
                      </small>
                    } @else if (reportShortText) {
                      <markdown class="nerf-report-text" [data]="reportShortText"></markdown>
                    }
                  </div>
                }
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      }

    </div>
  </form>
</div>

<!-- Guida delle schede parametri: aperta da openHelp() -->
<ng-template #helpDialog>
  <h2 mat-dialog-title class="d-flex align-items-center">
    <mat-icon class="mr-2" color="primary" aria-hidden="true">help_outline</mat-icon>
    @switch (helpSection) {
      @case ('fixed') {
        {{ 'components.nerf-simulator.help.fixed.title' | translate }}
      }
      @case ('costs') {
        {{ 'components.nerf-simulator.help.costs.title' | translate }}
      }
      @default {
        {{ 'components.nerf-simulator.help.editable.title' | translate }}
      }
    }
  </h2>
  <mat-dialog-content>
    <p class="mb-0">
      @switch (helpSection) {
        @case ('fixed') {
          {{ 'components.nerf-simulator.help.fixed.text' | translate }}
        }
        @case ('costs') {
          {{ 'components.nerf-simulator.help.costs.text' | translate }}
        }
        @default {
          {{ 'components.nerf-simulator.help.editable.text' | translate }}
        }
      }
    </p>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" type="button" mat-dialog-close>{{ 'generic.buttons.close' | translate }}</button>
  </mat-dialog-actions>
</ng-template>

<!-- Confronto simulazioni selezionate: un grafico a barre (ECharts) per metrica chiave -->
<ng-template #comparisonDialog>
  <h2 mat-dialog-title class="d-flex align-items-center">
    <mat-icon class="mr-2" color="primary" aria-hidden="true">bar_chart</mat-icon>
    {{ 'components.nerf-simulator.compare_simulations' | translate }}
  </h2>
  <mat-dialog-content>
    <!-- I 5 grafici come schede: si cambia cliccando la scheda o con le frecce ai lati (in modo ciclico) -->
    <div class="row no-gutters align-items-center">
      <div class="col-auto">
        <button mat-icon-button color="primary" type="button"
          [matTooltip]="'components.nerf-simulator.compare.previous' | translate"
          [attr.aria-label]="'components.nerf-simulator.compare.previous' | translate"
          (click)="showComparisonChart(-1)">
          <mat-icon>chevron_left</mat-icon>
        </button>
      </div>

      <!-- min-width 0: in Bootstrap 4 .col non lo imposta e i grafici non si restringerebbero -->
      <div class="col" style="min-width: 0">
        <mat-tab-group animationDuration="300ms"
          [selectedIndex]="comparisonChartType - 1"
          (selectedIndexChange)="comparisonChartType = $event + 1">
          @for (type of comparisonChartTypes; track type) {
            <mat-tab [label]="'components.nerf-simulator.compare.graph' | translate: { number: type }">
              <!-- Contenuto creato all'apertura della scheda: ECharts si dimensiona sulla scheda visibile -->
              <ng-template matTabContent>
                <p class="small text-muted text-center my-3">
                  @switch (type) {
                    @case (1) {
                      {{ 'components.nerf-simulator.compare.graph_1_hint' | translate }}
                    }
                    @case (2) {
                      {{ 'components.nerf-simulator.compare.graph_2_hint' | translate }}
                    }
                    @case (3) {
                      {{ 'components.nerf-simulator.compare.graph_3_hint' | translate }}
                    }
                    @case (4) {
                      {{ 'components.nerf-simulator.compare.graph_4_hint' | translate }}
                    }
                    @case (5) {
                      {{ 'components.nerf-simulator.compare.graph_5_hint' | translate }}
                    }
                  }
                </p>

                @switch (type) {
                  @case (1) {
                    <!-- px-3 contiene i margini negativi di .row dentro la scheda -->
                    <div class="px-3">
                      <div class="row">
                        @for (chart of comparisonCharts; track chart.labelKey) {
                          <div class="col-12 col-lg-6 mb-4">
                            <h6 class="mb-2">
                              {{ chart.labelKey | translate }}
                              @if (chart.unit) {
                                ({{ chart.unit }})
                              }
                            </h6>
                            <div echarts [options]="chart.options" style="height: 280px"></div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @case (2) {
                    <div echarts [options]="comparisonAltCharts[2]" style="height: 460px"></div>
                  }
                  @case (3) {
                    <div echarts [options]="comparisonAltCharts[3]" style="height: 460px"></div>
                  }
                  @case (4) {
                    <div echarts [options]="comparisonAltCharts[4]" style="height: 460px"></div>
                  }
                  @case (5) {
                    <div echarts [options]="comparisonAltCharts[5]" style="height: 460px"></div>
                  }
                }
              </ng-template>
            </mat-tab>
          }
        </mat-tab-group>
      </div>

      <div class="col-auto">
        <button mat-icon-button color="primary" type="button"
          [matTooltip]="'components.nerf-simulator.compare.next' | translate"
          [attr.aria-label]="'components.nerf-simulator.compare.next' | translate"
          (click)="showComparisonChart(1)">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="primary" type="button" mat-dialog-close>{{ 'generic.buttons.close' | translate }}</button>
  </mat-dialog-actions>
</ng-template>
